// import CallApp from "@alife/callapp";
import WakeToAlipay from "./wakeup/index";
// import CallApp from "@alife/callapp";
import Popver from "./popver/index";
import { isOurApp, isDingTalk, isUC, isWeChat, isBaidu } from "./util/useragent";
// import Slide from "./slide";
import Util from "./util/index";

// const Url = "alipays://platformapi/startapp?appId=2018032302435038&page=pages/myali/myali&query=";

function callGoTo(config, abtestFlag, url, refer, onlineAbtestChannel) {
    let abtest, abtestPopver;
    if (config["manual"]) {
        abtest = abtestFlag.manualAbtest;
        abtestPopver = abtestFlag.manualPopverAbtest;
    } else {
        abtest = abtestFlag.pageAbtest;
        abtestPopver = abtestFlag.pagePopverAbtest;
    }
    if (abtest) {
        //页面自己唤起
        if (abtestPopver) {
            //旺铺特俗需求
            Popver.init({
                imgUrl: abtestFlag.popverImage,
                manual: !!config["manual"],
                manualImageUrl: abtestFlag.manualImage,
                popverImageWidth: abtestFlag.popverImageWidth,
                popverImageText: abtestFlag.popverImageText,
                popverImageTextWidth: abtestFlag.popverImageTextWidth,
                ...abtestFlag,
                success: function () {
                    //打点
                    config && config.success && config.success();
                    if (window['goldlog'] && goldlog.record) {
                        let dpid = goldlog.pvid;
                        if (config && config.isDetail === true) {
                            goldlog.record('/1688seo.tinyapp.detailcall', 'CLK', 'dpid=' + dpid, 'GET')
                        } else {
                            goldlog.record('/1688seo.tinyapp.fronttinyapp', 'CLK', 'dpid=' + dpid, 'GET');
                        }
                    }
                    WakeToAlipay(url, refer);
                    //点击了app 5s没有唤起 就关掉
                    setTimeout(function () {
                        Popver.close();
                    }, 5000);
                },
                close: function () {
                    config && config.close && config.close();
                    if (window['goldlog'] && goldlog.record) {
                        let dpid = goldlog.pvid;
                        if (config && config.isDetail === true) {
                            goldlog.record('/1688seo.tinyapp.detailcancel', 'CLK', 'dpid=' + dpid, 'GET');
                        } else {
                            goldlog.record('/1688seo.tinyapp.frontcancel', 'CLK', 'dpid=' + dpid, 'GET');
                        }
                    }
                },
                goWebLogin: function () {
                    config && config.goWebLogin && config.goWebLogin();
                    //还是打取消的按钮
                    if (window['goldlog'] && goldlog.record) {
                        let dpid = goldlog.pvid;
                        if (config && config.isDetail === true) {
                            goldlog.record('/1688seo.tinyapp.viewbrowser', 'CLK', 'dpid=' + dpid, 'GET');
                        } else {
                            goldlog.record('/1688seo.tinyapp.viewbrowser', 'CLK', 'dpid=' + dpid, 'GET');
                        }
                    }
                }
            });
            setTimeout(function () {
                // 支付宝小程序需要通过schema进入, 需要唤起
                if ((isOurApp && !isDingTalk && !isUC) || isWeChat || isBaidu) {
                    return;
                }
                if (window['goldlog'] && goldlog.record) {
                    let dpid = goldlog.pvid;
                    goldlog.record('/1688seo.tinyapp.silentcall', 'CLK', 'dpid=' + dpid, 'GET');
                    //
                    if (onlineAbtestChannel) {
                        //切流
                        goldlog.record('/1688seo.tinyapp.1688seo.tinyapp.silentcall_a', 'CLK', 'dpid=' + dpid, 'GET');
                    } else {
                        goldlog.record('/1688seo.tinyapp.1688seo.tinyapp.silentcall_b', 'CLK', 'dpid=' + dpid, 'GET');
                    }
                }
                //自动唤起后续操作
                Util.autoCallAppAuction(function () {
                    //hide的时候
                    if (window['goldlog'] && goldlog.record) {
                        let dpid = goldlog.pvid;
                        goldlog.record('/1688_qyzb_new.call-app-time.call-success-app-time', 'CLK', 'dpid=' + dpid + "&d_t=" + new Date().getTime(), 'GET');
                    }
                }, function () {
                    //show的时候 回去又回来的时候
                });
                WakeToAlipay(url, refer);

            }, 500);
            return;
        } else {
            //静默唤起弹窗
            setTimeout(function () {
                // 支付宝小程序需要通过schema进入, 需要唤起
                if ((isOurApp && !isDingTalk && !isUC) || isWeChat) {
                    return;
                }
                if (window['goldlog'] && goldlog.record) {
                    let dpid = goldlog.pvid;
                    goldlog.record('/1688seo.tinyapp.silentcall', 'CLK', 'dpid=' + dpid, 'GET')
                    if (onlineAbtestChannel) {
                        //切流
                        goldlog.record('/1688seo.tinyapp.1688seo.tinyapp.silentcall_a', 'CLK', 'dpid=' + dpid, 'GET');
                    } else {
                        goldlog.record('/1688seo.tinyapp.1688seo.tinyapp.silentcall_b', 'CLK', 'dpid=' + dpid, 'GET');
                    }
                }
                //自动唤起后续操作 自动唤起
                Util.autoCallAppAuction(function () {
                    //hide的时候
                    if (window['goldlog'] && goldlog.record) {
                        let dpid = goldlog.pvid;
                        goldlog.record('/1688_qyzb_new.call-app-time.call-success-app-time', 'CLK', 'dpid=' + dpid + "&d_t=" + new Date().getTime(), 'GET');
                    }
                }, function () {
                    //show的时候 回去又回来的时候
                });
                WakeToAlipay(url, refer);
            }, 500);
            return;
        }
    }
}
/**
 * 切流唤起
 */
function callAbtestApp({ start, end, config, abtestFlag, _url, refer, onlineAbtestChannel }) {
    if (start > end) {
        // console.log('开始唤起支付宝啦');
        // if (abtestFlag.redPackage) {
        //     Slide({ refer });
        // }
        callGoTo(config, abtestFlag, _url, refer, onlineAbtestChannel);
    } else {
        config && config.fail && config.fail();
    }
}

export {
    callAbtestApp,
    callGoTo
}


// WEBPACK FOOTER //
// ./src/call-app.js